import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/authcontext";
import { useTenantRole } from "./TenantRoleDisplay";
import AccessDenied from "./AccessDenied";

interface RoleGuardProps {
  children: React.ReactNode;
  restrictedRoles?: string[];
  allowedRoles?: string[];
}

const RoleGuard: React.FC<RoleGuardProps> = ({
  children,
  restrictedRoles = [],
  allowedRoles = [],
}) => {
  const { auth, selectedTenantId } = useContext(AuthContext);
  const role = useTenantRole(selectedTenantId || "");

  if (!auth) {
    return <Navigate to="/login" replace />;
  }

  if (!role) {
    return <>{children}</>;
  }

  if (restrictedRoles.length > 0) {
    if (restrictedRoles.includes(role.role_key)) {
      return <AccessDenied />;
    }
  }

  let effectiveAllowedRoles = [...allowedRoles];
  if (
    effectiveAllowedRoles.includes("SUPERADMIN") ||
    effectiveAllowedRoles.includes("PLATFORM_ANALYST")
  ) {
    effectiveAllowedRoles.push("APIADMIN");
    effectiveAllowedRoles.push("API_ADMIN");
  }

  if (effectiveAllowedRoles.length > 0) {
    if (!effectiveAllowedRoles.includes(role.role_key)) {
      return <AccessDenied />;
    }
  }

  return <>{children}</>;
};

export default RoleGuard;
